import Svg, { SvgProps, Path } from 'react-native-svg';

const SoundIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M20.037 5.646a1 1 0 0 0-.8 1.627 12.907 12.907 0 0 1 .357 15.49 1 1 0 1 0 1.629 1.159A14.92 14.92 0 0 0 24 15.256c0-3.472-1.2-6.67-3.188-9.213a1 1 0 0 0-.775-.397zM11 7l-4.207 4H3a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h3.793L11 23V7zm3.738 1.592a1 1 0 0 0-.736 1.699A7.157 7.157 0 0 1 16 15.256a7.16 7.16 0 0 1-1.62 4.54 1 1 0 1 0 1.552 1.263A9.178 9.178 0 0 0 18 15.256a9.178 9.178 0 0 0-2.55-6.346 1 1 0 0 0-.712-.318z" />
  </Svg>
);

export default SoundIcon;
